import { useEffect, useMemo, useRef, useState } from "react";
import { CONNECTIVITY, createConnectivityMonitor, getConnectivityConfig } from "../utils/connectivity.js";

/**
 * SOK-04: estado de conectividad del tótem (`online | degraded | offline`).
 *
 * @param {object} style - config/styles del cliente; lee `style.global.connectivity`.
 * @param {(change: {status: string, previous: string, durationMs: number, latencyMs: number | null}) => void} [onChange]
 * @returns {'online' | 'degraded' | 'offline'}
 */
export function useConnectivity(style, onChange) {
  // El documento de estilos llega de nuevo con cada cambio en Firestore; el monitor solo se reinicia
  // si cambian los valores de conectividad.
  const configKey = JSON.stringify(getConnectivityConfig(style));
  const config = useMemo(() => JSON.parse(configKey), [configKey]);
  const [status, setStatus] = useState(() => (navigator.onLine === false ? CONNECTIVITY.OFFLINE : CONNECTIVITY.ONLINE));
  // onChange cambia en cada render del padre; se lee desde una ref para no reiniciar el monitor.
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    const monitor = createConnectivityMonitor({
      config,
      onChange: (change) => {
        setStatus(change.status);
        onChangeRef.current?.(change);
      },
    });
    setStatus(monitor.getStatus());
    monitor.start();
    return () => monitor.stop();
  }, [config]);

  return status;
}
